import { jsonFetch } from './fetch';

class UnparcableCSRFTokenException extends Error {}

const NAVIGATED_AWAY = 'NAVIGATED_AWAY';

const csrfToken = (() => {
  let cachedToken: string;
  return () => {
    try {
      if (!cachedToken) {
        // @ts-expect-error - Object is possibly null, which we catch
        const token: string = document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content');
        cachedToken = token;
      }

      return cachedToken;
    } catch (e) {
      const msg = `Trouble reading csrf token. ${e.message}`;
      throw new UnparcableCSRFTokenException(msg);
    }
  };
})();

// The window object is not available in some contexts,
// for those, we generate a simple fetch that includes the
// token but doesn't depend on window.
let csrfFetch = jsonFetch;

if (typeof window !== 'undefined') {
  window.csrfToken = csrfToken;
  csrfFetch = async function (url, options) {
    const eventAbortController = new AbortController();

    // Abort the request and ignore the error when the user navigates away from
    // the page.
    if (!options.signal) {
      const abortController = new AbortController();
      options.signal = abortController.signal;
      addEventListener(
        'beforeunload',
        () => {
          abortController.abort(
            new DOMException(
              'Request aborted, user navigated away',
              NAVIGATED_AWAY
            )
          );
        },
        {
          once: true,
          signal: eventAbortController.signal,
        }
      );
    }

    try {
      return await jsonFetch(url, options);
    } finally {
      // Remove the event listener when the request is done
      eventAbortController.abort();
    }
  };
}

export { csrfFetch };
